import React, { useEffect, useState } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";
import "./ClmsEmployee.css";
function ClmsEmployeeUpdate() {
    const empcode = localStorage.getItem('empcode');
    const empcompany = localStorage.getItem('empCompany');
    const { setLoading } = useLoading();
    const [showForm, setShowForm] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const initialFormState = {
        IsUpdate: 0,
        EmployeeCode: "",
        EmployeeName: "",
        FatherName: "",
        DOB: "",
        DOJ: "",
        Gender: "",
        DepartmentID: "",
        SubDepartmentID: "",
        LocationID: "",
        VenderID: "",
        Mobile: "",
        AadharNo: "",
        PermanentAddress: "",
        CurrentAddress: "",
        MaritalStatus: "",
        GradeID: "",
        DesignationID: "",
        PFNumber: "",
        ESICNumber: "",
        BankAccountNo: "",
        BankID: "",
        PANNumber: "",
        CostCenterID: "",
        QualificationID: "",
        PassingYear: "",
        PreviousExperienceYears: "",
        PlantID: "",
        CompanyID: "",
        ShiftID: "",
        ISActive: "",
        ImageFile: null,
        PhysicalDisability: "",
        BloodGroup: "",
        CriticalaManpower: "",
        IFSCCode: "",
        WeekOffID: "",
        ManagerCode: "",
        EmployeeType: "",
        EmployeeStatus: "",
        FloorWise: "",
        LineWise: "",
        EmployeeOldCode: ""
    };

    const [formData, setFormData] = useState(initialFormState);
    const [searchId, setSearchId] = useState('');
    const [errors, setErrors] = useState({});
    const [departments, setDepartments] = useState([]);
    const [subDepartments, setSubDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [grades, setGrades] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [banks, setBanks] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [plant, setPlant] = useState([]);
    const [company, setCompany] = useState([]);
    const [shift, setShift] = useState([]);
    const [vender, setVender] = useState([]);
    const [weekOff, setWeekOff] = useState([]);
    ///////////Search
    const [searchText, setSearchText] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedEmployeeCode, setSelectedEmployeeCode] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [blood, setBlood] = useState([]);
    const [employeetype, setEmployeeType] = useState([]);
    const [employeestatus, setEmployeeStatus] = useState([]);
    const [floorwise, setFloorWise] = useState([]);
    const [linewise, setLineWise] = useState([]);
    useEffect(() => {
        loadDropdowns();
    }, []);
    ///Search
    const handleInputChange = async (e) => {

        const value = e.target.value;
        setSearchText(value);

        if (value.length < 0) {
            setSuggestions([]);
            setShowSuggestions(false);
            return;
        }

        try {

            const response = await EmployeeProcessService.getEmployeeSearch(value); // API should return employee list
            if (response.data.statusCode === 200) {
                setSuggestions(response.data.result);
                setShowSuggestions(true);
            } else {
                setSuggestions([]);
                setShowSuggestions(false);
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };
    /////search
    const handleSelectSuggestion = (emp) => {
        const label = `${emp.employeeName} (${emp.employeeCode})`;
        setSearchText(label);
        setSelectedEmployeeCode(emp.employeeCode);
        setSuggestions([]);
        setShowSuggestions(false);
    };
    /////////
    const loadDropdowns = async () => {
        try {
            const [
                //deptRes, 
                locRes, gradeRes, desigRes, bankRes, qualRes, plantRes, companyRes, weekOffRes,
                //shiftRes, 
                venderRes,
                bloodRes, empStatus,] = await Promise.all([
                    //EmployeeProcessService.getDepartment(empcode),
                    EmployeeProcessService.getLocation(),
                    EmployeeProcessService.getGrades(),
                    EmployeeProcessService.getDesignation(),
                    EmployeeProcessService.getBank(),
                    EmployeeProcessService.getQualification(),
                    EmployeeProcessService.getPlant(empcode),
                    EmployeeProcessService.getCompany('User'),
                    EmployeeProcessService.getWeekOff(),
                    //EmployeeProcessService.getShift(),
                    EmployeeProcessService.getVender('User'),
                    EmployeeProcessService.getBlood(),
                    EmployeeProcessService.getEmployeeStatus()
                ]);
            //if (deptRes?.data?.statusCode === 200) setDepartments(deptRes.data.result);
            if (locRes?.data?.statusCode === 200) setLocations(locRes.data.result);
            if (gradeRes?.data?.statusCode === 200) setGrades(gradeRes.data.result);
            if (desigRes?.data?.statusCode === 200) setDesignations(desigRes.data.result);
            if (bankRes?.data?.statusCode === 200) setBanks(bankRes.data.result);
            if (qualRes?.data?.statusCode === 200) setQualifications(qualRes.data.result);
            if (plantRes?.data?.statusCode === 200) setPlant(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            if (weekOffRes?.data?.statusCode === 200) setWeekOff(weekOffRes.data.result);
            // if (shiftRes?.data?.statusCode === 200) setShift(shiftRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
            if (bloodRes?.data?.statusCode === 200) setBlood(bloodRes.data.result);
            if (empStatus?.data?.statusCode === 200) setEmployeeStatus(empStatus.data.result);
        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const handleClear = () => {
        setFormData(initialFormState);
        setErrors({});
    };

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        try {

            if (name === "CompanyID") {
                // Reset dependent dropdowns
                setFormData((prev) => ({
                    ...prev,
                    PlantID: "",
                    DepartmentID: "",
                    SubDepartmentID: "",
                }));
                setPlant([]);
                setDepartments([]);
                setSubDepartments([]);

                // Fetch plants by company
                const plantResponse = await EmployeeProcessService.getPlantByCompany(value);
                if (plantResponse.data.statusCode === 200) {
                    setPlant(plantResponse.data.result);
                }
            }

            if (name === "PlantID") {
                // Reset dept + subdept

                setFormData((prev) => ({
                    ...prev,
                    DepartmentID: "",
                    SubDepartmentID: "",
                }));
                setDepartments([]);
                setSubDepartments([]);

                // Fetch shift for this plant
                const shiftResponse = await EmployeeProcessService.getShift(value);
                if (shiftResponse.data.statusCode === 200) {
                    setShift(shiftResponse.data.result);
                } else {
                    setShift([]);
                }

                // Fetch departments by Plant + empcode

                const deptResponse = await EmployeeProcessService.getDepartment(empcode, value);

                if (deptResponse.data.statusCode === 200) {
                    setDepartments(deptResponse.data.result);
                } else {
                    setDepartments([]);
                }


                // Fetch Floor Wise bound by plant
                const floorResponse = await EmployeeProcessService.getFloorWise(value);
                if (floorResponse.data.statusCode === 200) {
                    setFloorWise(floorResponse.data.result);
                } else {
                    setFloorWise([]);
                }

                // Fetch Line Wise bound by plant
                // const lineResponse = await EmployeeProcessService.getLineWise(value);
                // if (lineResponse.data.statusCode === 200) {
                //     setLineWise(lineResponse.data.result);
                // } else {
                //     setLineWise([]);
                // }

                // Only fetch NEW employee code if this is a new record
                if (formData.IsUpdate === 0) {
                    const empResponse = await EmployeeProcessService.getEployeeCode(value);
                    if (empResponse.data.statusCode === 200 && empResponse.data.result) {
                        const employeeData = empResponse.data.result[0].id;
                        setFormData((prev) => ({
                            ...prev,
                            ISActive: 1,
                            EmployeeCode: employeeData || "",
                        }));
                    } else {
                        setFormData((prev) => ({ ...prev, EmployeeCode: "" }));
                    }
                }
            }

            if (name === "DepartmentID") {
                // Reset subdept when department changes
                setFormData((prev) => ({ ...prev, SubDepartmentID: "" }));
                setSubDepartments([]);

                // Fetch subdepartments
                const response = await EmployeeProcessService.getSubDepartment(value);
                if (response.data.statusCode === 200) {
                    setSubDepartments(response.data.result);
                } else {
                    setSubDepartments([]);
                }
            }

            if (name === "FloorWise") {

        console.log("Selected Floor ID:", value);

        // Clear selected LineWise whenever Floor changes
        setFormData(prev => ({
            ...prev,
            FloorWise: value,
            LineWise: ""
        }));

        // Clear line list if no floor selected
        if (!value) {
            setLineWise([]);
            return;
        }

                try {
            console.log("Calling getLineWise with Floor ID:", value);

            const lineResponse =
                await EmployeeProcessService.getLineWise(value);

            console.log("Line API Response:", lineResponse);

            if (lineResponse.data.statusCode === 200) {
                setLineWise(lineResponse.data.result || []);
            } else {
                setLineWise([]);
            }

        } catch (error) {
                    console.error("Error fetching lines:", error);
                    setLineWise([]);
                }
            }

        } catch (error) {
            console.error("Error in handleChange:", error);
        }
    };

    const validate = () => {
        const newErrors = {};
        const requiredFields = ['CompanyID', 'EmployeeName', 'FatherName', 'DOB', 'DOJ', 'Gender', 'Mobile',
            'AadharNo', 'VenderID', 'Gender', 'DepartmentID', 'PermanentAddress', 'ShiftID', 'WeekOffID', 'DesignationID', 'GradeID', 'EmployeeType'];
        requiredFields.forEach(field => {
            if (!formData[field] || formData[field].toString().trim() === '') {
                newErrors[field] = 'This field is required';
            }
        });

        if (formData.Mobile && !/^\d{10}$/.test(formData.Mobile)) {
            newErrors.Mobile = 'Invalid mobile number';
        }
        if (formData.AadharNo && !/^\d{12}$/.test(formData.AadharNo)) {
            newErrors.AadharNo = 'Invalid Aadhar number';
        }
        if (formData.DOB && !is18OrOlder(formData.DOB)) {
            newErrors.DOB = 'Employee must be at least 18 years old.';
        }

        return newErrors;
    };

    const is18OrOlder = (dateString) => {
        const dob = new Date(dateString);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const m = today.getMonth() - dob.getMonth();
        return age > 18 || (age === 18 && m >= 0);
    };
    const normalizeData = (data) => ({

        //IsUpdate: data.isUpdate || "",
        EmployeeCode: data.employeeCode || "",
        EmployeeName: data.employeeName || "",
        FatherName: data.fatherName || "",
        DOB: data.dob ? data.dob.slice(0, 10) : "",
        DOJ: data.doj ? data.doj.slice(0, 10) : "",
        Gender: data.gender || "",
        DepartmentID: data.departmentID || "",
        SubDepartmentID: data.subDepartmentID || "",
        LocationID: data.locationID || "",
        VenderID: data.venderID || "",
        Mobile: data.mobile || "",
        AadharNo: data.aadharNo || "",
        PermanentAddress: data.permanentAddress || "",
        CurrentAddress: data.currentAddress || "",
        MaritalStatus: data.maritalStatus || "",
        GradeID: data.gradeID || "",
        DesignationID: data.designationID || "",
        PFNumber: data.pfNumber || "",
        ESICNumber: data.esicNumber || "",
        BankAccountNo: data.bankAccountNo || "",
        BankID: data.bankID || "",
        PANNumber: data.panNumber || "",
        CostCenterID: data.costCenterID || "",
        QualificationID: data.qualificationID || "",
        PassingYear: data.passingYear || "",
        PreviousExperienceYears: data.previousExperienceYears || "",
        PlantID: data.plantID || "",
        CompanyID: data.companyID || "",
        ShiftID: data.shiftID || "",
        ISActive: data.isActive || "",
        CriticalaManpower: data.criticalaManpower || "",
        BloodGroup: data.bloodGroup || "",
        PhysicalDisability: data.physicalDisability || "",
        IFSCCode: data.ifscCode || "",
        WeekOffID: data.weekOffID || "",
        ManagerCode: data.managerCode || "",
        EmployeeType: data.employeeType || "",
        EmployeeStatus: data.employeeStatus || "",
        FloorWise: data.floorWise || "",
        LineWise: data.lineWise || "",
        EmployeeOldCode: data.employeeOldCode || ""
    });

    const handleSearch = async () => {
        if (!selectedEmployeeCode) {
            toast.warning('Please select an employee from suggestions.');
            return;
        }

        try {
            setLoading(true);

            const response = await EmployeeProcessService.getCLMSEmployeeData(selectedEmployeeCode);

            if (response.data?.result?.length > 0) {
                // Step 1: Load SubDepartments based on DepartmentID


                // setFormData(cleanedData);
                // setShowForm(true);
                // setIsEditMode(false); // 👈 IMPORTANT (default view mode)

                const subDeptRes = await EmployeeProcessService.getSubDepartment(response.data.result[0].departmentID);
                if (subDeptRes.data.statusCode === 200) {
                    setSubDepartments(subDeptRes.data.result);
                }

                // Step 2: Load Shifts based on PlantID
                const shiftRes = await EmployeeProcessService.getShift(response.data.result[0].plantID);
                if (shiftRes.data.statusCode === 200) {
                    setShift(shiftRes.data.result);
                }

                // ✅ Step 3: Load Departments based on PlantID + empcode
                const deptRes = await EmployeeProcessService.getDepartment(empcode, response.data.result[0].plantID);
                if (deptRes.data.statusCode === 200) {
                    setDepartments(deptRes.data.result);
                }

                // ✅ Step 4: Load FloorWise
                const floorRes = await EmployeeProcessService.getFloorWise(response.data.result[0].plantID);
                if (floorRes.data.statusCode === 200) {
                    setFloorWise(floorRes.data.result);
                } else {
                    setFloorWise([]);
                }

                // ✅ Step 5: Load LineWise
                const lineRes = await EmployeeProcessService.getLineWise(response.data.result[0].plantID);
                if (lineRes.data.statusCode === 200) {
                    setLineWise(lineRes.data.result);
                } else {
                    setLineWise([]);
                }
                const cleanedData = normalizeData(response.data.result[0]);
                setFormData(cleanedData);
                setShowForm(true);
                setIsEditMode(false)
                showToast("Employee data loaded.", 'success');
            } else {
                setShowForm(false);
                toast.error("Employee not found.");
            }
        } catch (error) {
            toast.error("Error fetching employee.");
        } finally {
            setLoading(false);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length) {
            setErrors(validationErrors);
            return;
        }
        const confirmed = window.confirm("Are you sure you want to Update?");
        if (!confirmed) return; // Cancel save if user clicks "Cancel"
        try {
            setLoading(true);
            setFormData(prev => ({
                ...prev,
                IsUpdate: 1,
            }));
            const res = await EmployeeProcessService.setEmployee(formData);
            if (res.data.statusCode === 200) {
                showToast("Employee data saved successfully.", 'success', { autoClose: 1500 });
                setFormData(initialFormState);
                handleClear();
                setSearchId('');
                setShowForm(false);
            } else {

                toast.error("Error saving data");
            }
        } catch (err) {
            console.error(err);
            toast.error("Submission failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="col-12 mb-3 border-bottom pb-2">
                <h4 className="text-left text-primary"> Employee Update</h4>
            </div>
            <div className="container form-group">
                <div className="mb-4 p-3 border rounded bg-light shadow-sm position-relative">
                    <label className="form-label fw-bold text-primary">Search by Employee ID or Name</label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control border-primary"
                            placeholder="Type to search..."
                            value={searchText}
                            onChange={handleInputChange}
                        />
                        <button
                            className="btn btn-outline-primary"
                            onClick={handleSearch}
                            type="button"
                        >
                            Search
                        </button>
                    </div>

                    {showSuggestions && suggestions.length > 0 && (
                        <ul className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000 }}>
                            {suggestions.map((emp) => (
                                <li
                                    key={emp.employeeCode}
                                    className="list-group-item list-group-item-action"
                                    onClick={() => handleSelectSuggestion(emp)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {emp.employeeName} ({emp.employeeCode})
                                </li>
                            ))}
                        </ul>
                    )}
                </div>



                {showForm && (
                    <form>
                        <div className="row">
                            <h7 className="text-start fw-bold text-info pb-2 mb-1">
                                <i className="bi bi-building"></i> Company & Employment Details</h7>
                            <div className="form-group col-md-4">
                                <label>Company<span style={{ color: 'red' }}>*</span></label>
                                <select name="CompanyID" value={formData.CompanyID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Company</option>
                                    {company.map(comp => (
                                        <option key={comp.id} value={comp.id}>{comp.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.CompanyID}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Employee Code</label>
                                <input name="EmployeeCode" value={formData.EmployeeCode} readOnly className="form-control bg-light" />
                            </div>

                            <div className="form-group col-md-4">
                                <label>Employee Name<span style={{ color: 'red' }}>*</span></label>
                                <input name="EmployeeName" value={formData.EmployeeName} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.EmployeeName}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Father Name<span style={{ color: 'red' }}>*</span></label>
                                <input name="FatherName" value={formData.FatherName} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.FatherName}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>DOB<span style={{ color: 'red' }}>*</span></label>
                                <input type="date" name="DOB" value={formData.DOB} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.DOB}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>DOJ<span style={{ color: 'red' }}>*</span></label>
                                <input type="date" name="DOJ" value={formData.DOJ} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.DOJ}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Gender<span style={{ color: 'red' }}>*</span></label>
                                <select name="Gender" value={formData.Gender} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Gender</option>
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                    <option value="O">Other</option>
                                </select>
                                <div className="text-danger">{errors.Gender}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Marital Status<span style={{ color: 'red' }}>*</span></label>
                                <select name="MaritalStatus" value={formData.MaritalStatus} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Status</option>
                                    <option value="Unmarried">Unmarried</option>
                                    <option value="Married">Married</option>
                                    <option value="Divorced">Divorced</option>
                                </select>
                                <div className="text-danger">{errors.MaritalStatus}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Physical Disability</label>
                                <select name="PhysicalDisability" value={formData.PhysicalDisability} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Value</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                <div className="text-danger">{errors.ISActive}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Blood Group</label>
                                {/* <input name="BloodGroup" value={formData.BloodGroup} onChange={handleChange} className="form-control" /> */}
                                <select name="BloodGroup" value={formData.BloodGroup} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Blood</option>
                                    {blood.map(blood => (
                                        <option key={blood.id} value={blood.id}>{blood.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.BloodGroup}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Manager Code<span style={{ color: 'red' }}>*</span></label>
                                <input name="ManagerCode" value={formData.ManagerCode} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.ManagerCode}</div>
                            </div>

                            <h7 className="text-start fw-bold text-info pb-2 mb-1">
                                <i className="bi bi-building"></i> Work Information</h7>
                            <div className="form-group col-md-4">
                                <label>Plant<span style={{ color: 'red' }}>*</span></label>
                                <select name="PlantID" value={formData.PlantID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Plant</option>
                                    {plant.map(plan => (
                                        <option key={plan.id} value={plan.id}>{plan.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.PlantID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Shift<span style={{ color: 'red' }}>*</span></label>
                                <select name="ShiftID" value={formData.ShiftID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Shift</option>
                                    {shift.map(sft => (
                                        <option key={sft.id} value={sft.id}>{sft.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.ShiftID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Department<span style={{ color: 'red' }}>*</span></label>
                                <select name="DepartmentID" value={formData.DepartmentID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Department</option>
                                    {departments.map(dept => (
                                        <option key={dept.id} value={dept.id}>{dept.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.DepartmentID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Sub Department</label>
                                <select name="SubDepartmentID" value={formData.SubDepartmentID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Sub Department</option>
                                    {subDepartments.map(sub => (
                                        <option key={sub.id} value={sub.id}>{sub.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.SubDepartmentID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Designation<span style={{ color: 'red' }}>*</span></label>
                                <select name="DesignationID" value={formData.DesignationID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Designation</option>
                                    {designations.map(d => (
                                        <option key={d.id} value={d.id}>{d.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.DesignationID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Grade<span style={{ color: 'red' }}>*</span></label>
                                <select name="GradeID" value={formData.GradeID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Grade</option>
                                    {grades.map(g => (
                                        <option key={g.id} value={g.id}>{g.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.GradeID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Cost Center</label>
                                <input name="CostCenterID" value={formData.CostCenterID} onChange={handleChange}
                                    onKeyDown={(e) => {
                                        // Allow: backspace, delete, tab, escape, enter, arrows
                                        if (
                                            e.key === "Backspace" ||
                                            e.key === "Delete" ||
                                            e.key === "Tab" ||
                                            e.key === "Escape" ||
                                            e.key === "Enter" ||
                                            (e.key >= "0" && e.key <= "9") ||
                                            e.key.startsWith("Arrow")
                                        ) {
                                            return;
                                        }

                                        e.preventDefault(); // Block the key
                                        alert("Only numbers are allowed.");
                                    }}
                                    className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.CostCenterID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Location</label>
                                <select name="LocationID" value={formData.LocationID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Location</option>
                                    {locations.map(loc => (
                                        <option key={loc.id} value={loc.id}>{loc.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.LocationID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Vender<span style={{ color: 'red' }}>*</span></label>
                                <select name="VenderID" value={formData.VenderID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Shift</option>
                                    {vender.map(ven => (
                                        <option key={ven.id} value={ven.id}>{ven.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.VenderID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Week Off<span style={{ color: 'red' }}>*</span></label>
                                <select name="WeekOffID" value={formData.WeekOffID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select WeekOff</option>
                                    {weekOff.map(week => (
                                        <option key={week.id} value={week.id}>{week.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.WeekOffID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Critical Manpower</label>
                                <select name="CriticalaManpower" value={formData.CriticalaManpower} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Value</option>
                                    <option value="1">Yes</option>
                                    <option value="0">NO</option>
                                </select>
                                <div className="text-danger">{errors.CriticalaManpower}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Employee Type<span style={{ color: 'red' }}>*</span></label>
                                <select name="EmployeeType" value={formData.EmployeeType} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Type</option>
                                    <option value="Contractual">Contractual</option>
                                    <option value="Permanent">Permanent</option>
                                </select>
                                <div className="text-danger">{errors.EmployeeType}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Employee Status</label>
                                <select name="EmployeeStatus" value={formData.EmployeeStatus} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Status</option>
                                    {employeestatus.map(status => (
                                        <option key={status.id} value={status.id}>{status.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.EmployeeStatus}</div>
                            </div>


                            <div className="form-group col-md-4">
                                <label>Floor Wise</label>
                                <select name="FloorWise" value={formData.FloorWise} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Floor</option>
                                    {floorwise.map(floors => (
                                        <option key={floors.id} value={floors.id}>{floors.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.FloorWise}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Line Wise</label>
                                <select name="LineWise" value={formData.LineWise} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Line</option>
                                    {linewise.map(line => (
                                        <option key={line.id} value={line.id}>{line.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.LineWise}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Employee OLD Code</label>
                                <input name="EmployeeOldCode" value={formData.EmployeeOldCode} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.EmployeeOldCode}</div>
                            </div>

                            <h7 className="text-start fw-bold text-info pb-2 mb-1">
                                <i className="bi bi-building"></i> Contact & Identification</h7>
                            <div className="form-group col-md-4">
                                <label>Aadhar No<span style={{ color: 'red' }}>*</span></label>
                                <input name="AadharNo" value={formData.AadharNo}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            AadharNo: e.target.value.replace(/\s+/g, '') // remove all spaces
                                        })
                                    }
                                    className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.AadharNo}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>PAN Number</label>
                                <input name="PANNumber" value={formData.PANNumber} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.PANNumber}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Mobile Number<span style={{ color: 'red' }}>*</span></label>
                                <input name="Mobile" value={formData.Mobile} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.Mobile}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Permanent Address</label>
                                <input name="PermanentAddress" value={formData.PermanentAddress} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.PermanentAddress}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Current Address</label>
                                <input name="CurrentAddress" value={formData.CurrentAddress} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.CurrentAddress}</div>
                            </div>

                            <h7 className="text-start fw-bold text-info pb-2 mb-1">
                                <i className="bi bi-building"></i> Bank & Statutory Details</h7>

                            <div className="form-group col-md-4">
                                <label>PF Number</label>
                                <input name="PFNumber" value={formData.PFNumber} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.PFNumber}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>ESIC Number</label>
                                <input name="ESICNumber" value={formData.ESICNumber} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.ESICNumber}</div>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Bank</label>
                                <select name="BankID" value={formData.BankID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Bank</option>
                                    {banks.map(b => (
                                        <option key={b.id} value={b.id}>{b.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.BankID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Bank Account No</label>
                                <input name="BankAccountNo" value={formData.BankAccountNo} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.BankAccountNo}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Bank IFSC Code</label>
                                <input name="IFSCCode" value={formData.IFSCCode} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.IFSCCode}</div>
                            </div>
                            <h7 className="text-start fw-bold text-info pb-2 mb-1">
                                <i className="bi bi-building"></i>  Qualification & Experience</h7>
                            <div className="form-group col-md-4">
                                <label>Qualification</label>
                                <select name="QualificationID" value={formData.QualificationID} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Qualification</option>
                                    {qualifications.map(q => (
                                        <option key={q.id} value={q.id}>{q.name}</option>
                                    ))}
                                </select>
                                <div className="text-danger">{errors.QualificationID}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Passing Year</label>
                                <input name="PassingYear" value={formData.PassingYear} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.PassingYear}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Previous Experience (Years)</label>
                                <input name="PreviousExperienceYears" value={formData.PreviousExperienceYears} onChange={handleChange} className="form-control" disabled={!isEditMode} />
                                <div className="text-danger">{errors.PreviousExperienceYears}</div>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Is Active</label>
                                <select name="ISActive" value={formData.ISActive} onChange={handleChange} className="form-select" disabled={!isEditMode}>
                                    <option value="">Select Active</option>
                                    <option value="1">True</option>
                                    <option value="0">False</option>
                                </select>
                                <div className="text-danger">{errors.ISActive}</div>
                            </div>
                            <div className="col-12 mt-3 text-center">
                                {!isEditMode ? (
                                    <button
                                        type="button"
                                        className="btn btn-warning me-2"
                                        onClick={(e) => {
                                            e.preventDefault();   // ✅ STOP REFRESH
                                            setIsEditMode(true);
                                        }}
                                    >
                                        Edit
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={handleSubmit}
                                    >
                                        Save Employee
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </>
    );
};

export default ClmsEmployeeUpdate